import { type Game, GameIdentifier } from "shared-types/games";
import { useBlindTest } from "./useBlindTest";
import {
	isAirconsoleActivatedSelector,
	isBlindTestActivatedSelector,
	isRouletteActivatedSelector,
} from "@redux/featureFlags/selector";
import { useSelector } from "react-redux";
import { userContextSelector } from "@redux/user/selectors";
import { UserContext } from "shared-types/user";
import { languageSelector } from "@redux/language";

export function useGames() {
	const { openBlindTestTabs } = useBlindTest();
	const isRouletteActivated = useSelector(isRouletteActivatedSelector);
	const isBlindTestActivated = useSelector(isBlindTestActivatedSelector);
	const isAirConsoleActivated = useSelector(isAirconsoleActivatedSelector);
	const userContext = useSelector(userContextSelector);
	const currentLanguage = useSelector(languageSelector);

	const THIS_IS_BLINDTEST: Game = {
		id: GameIdentifier.THIS_IS_BLINDTEST.toString(),
		identifier: GameIdentifier.THIS_IS_BLINDTEST,
		name: "This is Blindtest",
		coverFilename: `${currentLanguage}/this-is-blind.png`,
		onClick: () => userContext === UserContext.BAM && openBlindTestTabs(),
		in_app: userContext === UserContext.TSL
	};

	const AIRCONSOLE: Game = {
		id: GameIdentifier.AIRCONSOLE.toString(),
		identifier: GameIdentifier.AIRCONSOLE,
		name: "AirConsole",
		coverFilename: "",
		url: "https://www.airconsole.com/?embed=1&role=screen",
	};

	const ROULETTE: Game = {
		id: GameIdentifier.ROULETTE.toString(),
		identifier: GameIdentifier.ROULETTE,
		name: "Roulette",
		coverFilename:
			userContext === UserContext.BAM ? "bam-roulette.jpg" : "tsl-roulette.jpg",
	};

	const games: Game[] = [];

	if (isRouletteActivated) {
		games.push(ROULETTE);
	}

	if (isBlindTestActivated) {
		games.push(THIS_IS_BLINDTEST);
	}

	return {
		games,
		airConsole: {
			game: AIRCONSOLE,
			isActivated: isAirConsoleActivated,
		},
		roulette: {
			game: ROULETTE,
			isActivated: isRouletteActivated,
		},
		blindTest: {
			game: THIS_IS_BLINDTEST,
			isActivated: isBlindTestActivated,
		},
	};
}
